import RemoteAccessAuditConfigurationPage from '@totem/components/services/remoteAccess/auditConfiguration/RemoteAccessAuditConfigurationPage';
import Auth0RoleDetailsPage from '@totem/components/services/remoteAccess/auth0role/details/Auth0RoleDetailsPage';
import Auth0UserDetailsPage from '@totem/components/services/remoteAccess/auth0users/details/Auth0UserDetailsPage';
import RemoteAccessDashboardPage from '@totem/components/services/remoteAccess/dashboard/remoteAccessDashboardPage';
import RemoteAccessBuildingAuditPage from '@totem/components/services/remoteAccess/v2/buildingAudit/RemoteAccessBuildingAuditPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import {
  securityGroupCheckConstraintAny,
  securityGroupCheckConstraintEmpty,
} from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const remoteAccessRoutes: Route[] = [
  {
    path: 'remoteAccessDashboard',
    pageTitle: 'Remote Access',
    component: RemoteAccessDashboardPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access Governance' }],
    render: (userProfile: UserProfile) =>
      permissions.remoteAccess.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'remoteAccessUsers',
    pageTitle: 'Remote Access',
    component: RemoteAccessDashboardPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access Users' }],
    render: (userProfile: UserProfile) =>
      permissions.remoteAccess.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'remoteAccess/auth0role/:id',
    pageTitle: 'Remote Access Role',
    component: Auth0RoleDetailsPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access Role' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'remoteAccess/auth0user/:email',
    pageTitle: 'Remote Access User',
    component: Auth0UserDetailsPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access User' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'remoteAccess/auditconfig',
    pageTitle: 'Remote Access Audit Configuration',
    component: RemoteAccessAuditConfigurationPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access Audit Configuration' }],
    render: (userProfile: UserProfile) =>
      permissions.remoteAccessAdmin.hasPermissions(
        userProfile,
        securityGroupCheckConstraintEmpty,
      ),
  },
  {
    path: 'remoteAccess/audit/:buildingId',
    pageTitle: 'Remote Access Audit',
    component: RemoteAccessBuildingAuditPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access Audit' }],
    // Same V2 page as remoteAccess/userAudit/:buildingId — the legacy
    // per-role vs per-user-all-roles distinction is superseded by the
    // bulk multi-select + per-role toggle-off already in RemoveUsersDialog.
    render: (userProfile: UserProfile) =>
      permissions.remoteAccess.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'remoteAccess/userAudit/:buildingId',
    pageTitle: 'Remote Access User Audit',
    component: RemoteAccessBuildingAuditPage,
    exact: true,
    breadcrumbs: [{ label: 'Remote Access User Audit' }],
    render: (userProfile: UserProfile) =>
      permissions.remoteAccess.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
